/**
 * Theme Scripts
 *
 * @package BernskioldMedia\WPP\Forge
 */

import Accordion from "./components/accordion";
import Carousel from "@bernskioldmedia/carousel";
import Counter from "./components/counters";
import Modals from "./components/modal";
import scrollLock from "./components/scrollLock";
import Shelves from "./components/shelves";
import smoothScroll from "./components/smoothscroll";
import Sticky from "./components/sticky";
import stickyHeader from "./components/stickyHeader";
import Toggle from "./components/toggle";

document.addEventListener( "DOMContentLoaded", () => {

	new Accordion();
	new Carousel();
	new Counter();
	new Shelves();
	new Sticky();
	new Toggle();

	smoothScroll.init();
	stickyHeader.init();

	Modals();
	scrollLock();

} );
